<template>
  <v-row
    v-if="totalItems > 0"
    class="mt-2"
    align="center"
    no-gutters
  >
    <v-col cols="11">
      <v-pagination
        :value="page"
        :length="pages"
        :total-visible="totalVisible"
        @input="onPageChange"
      ></v-pagination>
    </v-col>
    <v-col cols="1">
      <v-select
        :items="perPageOptions"
        :value="itemsPerPage"
        hide-details
        @change="onItemsPerPageChange"
      ></v-select>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'Paginator',
    props: {
      totalItems: {
        type: Number,
        default: 0,
      },
      page: {
        type: Number,
        default: 1,
      },
      itemsPerPage: {
        type: Number,
        default: 10,
      },
      perPageOptions: {
        type: Array,
        default: () => [10, 20, 40, 60, 80, 100],
      },
      totalVisible: {
        type: Number,
        default: 10,
      },
    },
    computed: {
      pages() {
        if (!this.itemsPerPage) {
          return 0;
        }
        return Math.ceil(this.totalItems / this.itemsPerPage);
      },
    },
    methods: {
      onPageChange(page) {
        this.$emit('update:page', page);
        this.$emit('change');
      },
      onItemsPerPageChange(itemsPerPage) {
        this.$emit('update:itemsPerPage', itemsPerPage);
        this.$emit('update:page', 1);
        this.$emit('change');
      },
    },
  };
</script>

<style scoped>

</style>
